import { Link } from "react-router-dom";
import { categories } from "@/mocks/topics";

export default function Footer() {
  return (
    <footer className="mt-auto w-full bg-foreground-900 text-background-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-mic-2-fill text-lg"></i>
              </span>
              <strong className="font-heading text-lg font-bold text-background-50">
                吃瓜观测站
              </strong>
            </div>
            <p className="mt-4 font-label text-sm leading-relaxed text-background-300">
              只做归档与对比，不对当事人做道德评判。把各方说法放在同一版面上，判断权留给你。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-800 text-background-200"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold tracking-wide text-background-50">
              站内导航
            </h4>
            <ul className="mt-4 space-y-3 font-label text-sm">
              <li>
                <Link to="/" className="text-background-300 transition-colors hover:text-accent-400">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/list" className="text-background-300 transition-colors hover:text-accent-400">
                  大瓜合集
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-300 transition-colors hover:text-accent-400">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-background-300 transition-colors hover:text-accent-400">
                  联系与投稿
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold tracking-wide text-background-50">
              热门分类
            </h4>
            <ul className="mt-4 space-y-3 font-label text-sm">
              {categories
                .filter((c) => c !== "全部")
                .slice(0, 5)
                .map((c) => (
                  <li key={c}>
                    <Link
                      to={`/list?category=${encodeURIComponent(c)}`}
                      className="text-background-300 transition-colors hover:text-accent-400"
                    >
                      {c}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold tracking-wide text-background-50">
              联系与投稿
            </h4>
            <p className="mt-4 font-label text-sm leading-relaxed text-background-300">
              有线索或发现说法出入，欢迎发邮件告诉我们，我们会在核实后归档。
            </p>
            <a
              href="mailto:tip@chigua-guancha.example.com"
              className="mt-4 inline-flex items-center gap-2 whitespace-nowrap font-label text-sm text-accent-400 transition-colors hover:text-accent-300"
            >
              <i className="ri-mail-send-line"></i>
              tip@chigua-guancha.example.com
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start gap-3 border-t border-foreground-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-background-400">
            © 2026 吃瓜观测站 · 内容均为公开信息的整理与对比，仅供参考
          </p>
          <p className="font-label text-xs text-background-400">
            理性吃瓜 · 一切以当事人及官方说明为准
          </p>
        </div>
      </div>
    </footer>
  );
}